import { CATALYST_COLORS_WITH_HEXCODES } from "@certa/catalyst/constants/styles";
import type { BoxProps, TextProps } from "../engines/coreComponents/types";
import { BoxNode, TextNode } from "../engines/renderingEngine/primitiveNodes";

export const EmptyProcess = () => {
  const container = BoxNode({
    key: "EmptyProcess",
    style: emptyProcessContainerStyle,
    children: [
      TextNode({
        key: "EmptyProcess-Header",
        text: "Empty workflow",
        textStyle: emptyProcessHeaderTextStyle,
        style: {},
        children: []
      }),
      TextNode({
        key: "EmptyProcess-Text",
        text: "Please click on Edit to start building your workflow",
        textStyle: emptyProcessTextStyle,
        style: {},
        children: []
      })
    ]
  });

  return container;
};

const emptyProcessContainerStyle: BoxProps["style"] = {
  width: "100%",
  backgroundColor: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_200,
  paddingBottom: 40,
  paddingTop: 40,
  paddingLeft: 40,
  paddingRight: 40,
  borderRadius: 8,
  borderWidth: 1,
  borderColor: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,
  gapRow: 16
};

const emptyProcessHeaderTextStyle: TextProps["textStyle"] = {
  color: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_700,
  fontSize: 24
};

const emptyProcessTextStyle: TextProps["textStyle"] = {
  color: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_600,
  fontSize: 16
};
